<template>
	<div>
		<!-- 三方开票抽屉：导入待开票 / 导出已开票（需求 7112061691） -->
		<el-drawer title="三方开票" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
			size="560px" @close="close" append-to-body>
			<div class="drawer-content">
				<el-tabs v-model="activeTab">
					<!-- 导入 Tab -->
					<el-tab-pane label="导入待开票" name="import">
						<el-alert type="warning" :closable="false" class="MB10">
							<div slot="title">大麦、猫眼请直接上传平台导出的原始 Excel，不需要修改表头。成功记录会直接创建或覆盖待开票申请。</div>
						</el-alert>
						<el-form label-width="90px" size="small">
							<el-form-item label="导入类型" required>
								<el-radio-group v-model="importType">
									<el-radio label="maoyan">猫眼</el-radio>
									<el-radio label="damai">大麦</el-radio>
									<el-radio label="common">通用</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item v-if="importType === 'common'" label-width="0" class="template-link">
								<span>其他渠道请按秀动标准格式填写</span>
								<el-button type="text" icon="el-icon-download"
									@click="downloadTemplate">下载通用 Excel 模板</el-button>
							</el-form-item>
						</el-form>
						<el-upload drag action :http-request="uploadExcel" :auto-upload="false" ref="upload"
							accept=".xls, .xlsx" :show-file-list="true" :before-upload="beforeUpload"
							:file-list="fileList" :on-change="onChange" :on-remove="onRemove" :disabled="uploadLoading">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								<template v-if="importType">将文件拖到此处，或<em>点击选择文件</em></template>
								<template v-else><strong>请先选择导入类型</strong></template>
							</div>
							<div slot="tip" class="el-upload__tip color-danger">只能上传xls/xlsx文件，且最多不超过2W行；上传后直接解析执行，无逐行预览和确认步骤</div>
						</el-upload>
					</el-tab-pane>

					<!-- 导出 Tab -->
					<el-tab-pane label="导出已开票" name="export">
						<el-alert type="warning" :closable="false" class="MB10">
							<div slot="title">只导出第三方来源且已开票的申请。提交后生成后台下载任务，请前往"下载任务"下载 ZIP 文件。</div>
						</el-alert>
						<el-form label-width="90px" size="small">
							<el-form-item label="渠道">
								<el-select v-model="exportForm.channel" style="width: 100%">
									<el-option label="全部渠道" value="all"></el-option>
									<el-option label="大麦" value="damai"></el-option>
									<el-option label="猫眼" value="maoyan"></el-option>
									<el-option label="其他" value="other"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="时间类型" required>
								<el-radio-group v-model="exportForm.timeType">
									<el-radio label="1">申请创建时间</el-radio>
									<el-radio label="2">开票完成时间</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="时间范围" required>
								<el-date-picker v-model="exportRange" type="datetimerange" start-placeholder="开始日期"
									end-placeholder="结束日期" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss"
									:default-time="['00:00:00', '23:59:59']" unlink-panels>
								</el-date-picker>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="drawer-footer">
				<el-button v-if="!btnLoading" @click="close">取消</el-button>
				<el-button v-if="activeTab === 'import'" type="primary" @click="onSubmitImport" :loading="btnLoading"
					:disabled="canSubmit">上传并导入</el-button>
				<el-button v-else type="primary" @click="onSubmitExport" :loading="btnLoading">导出</el-button>
			</div>

			<!-- 导入结果浮层 -->
			<el-dialog title="导入完成" :visible.sync="resultVisible" width="560px" append-to-body
				:close-on-click-modal="false" center>
				<div class="import-summary" v-if="importResult">
					<div><span>总条数</span><strong>{{ importResult.total }}</strong></div>
					<div class="success"><span>新建成功</span><strong>{{ importResult.newCount }}</strong></div>
					<div class="success"><span>覆盖成功</span><strong>{{ importResult.coverCount }}</strong></div>
					<div class="ignored"><span>已开票忽略</span><strong>{{ importResult.ignoreCount }}</strong></div>
					<div class="failed"><span>失败</span><strong>{{ importResult.failCount }}</strong></div>
				</div>
				<template v-if="importResult && importResult.failCount > 0">
					<div class="failure-head">
						<div><strong>失败明细</strong><span>成功记录已落库，不受失败记录影响</span></div>
						<el-button size="mini" @click="copyErrors">复制明细</el-button>
					</div>
					<pre class="failure-text">{{ failText }}</pre>
				</template>
				<span slot="footer">
					<el-button type="primary" @click="closeResult">知道了</el-button>
				</span>
			</el-dialog>
		</el-drawer>
	</div>
</template>

<script>
	import {
		uploadFileTmp
	} from '@/assets/js/commonApi.js';

	export default {
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				uploadLoading: false,
				activeTab: 'import',
				// 导入
				importType: '',
				fileList: [],
				canSubmit: true,
				// 导出
				exportForm: {
					channel: 'all',
					timeType: '1'
				},
				exportRange: [],
				// 导入结果
				resultVisible: false,
				importResult: null
			}
		},
		computed: {
			failText() {
				if (!this.importResult || !this.importResult.failList) {
					return '';
				}
				return this.importResult.failList.map(e => `${e.thirdOrderId}｜${e.reason}`).join('\n');
			}
		},
		methods: {
			show() {
				this.drawerShow = true;
			},
			close() {
				this.importType = '';
				this.fileList = [];
				this.canSubmit = true;
				this.exportForm = {
					channel: 'all',
					timeType: '1'
				};
				this.exportRange = [];
				if (this.$refs.upload) {
					this.$refs.upload.clearFiles();
				}
				this.drawerShow = false;
			},
			// 下载通用模板（public 静态文件）
			downloadTemplate() {
				window.open('/template/' + encodeURIComponent('通用三方开票导入模板.xlsx'));
			},
			// 提交导入（触发上传）
			onSubmitImport() {
				if (!this.importType) {
					return this.$message.error('请先选择导入类型');
				}
				if (!this.fileList.length) {
					return this.$message.error('请先选择要导入的 Excel 文件');
				}
				this.$refs.upload.submit();
			},
			// 上传并导入
			async uploadExcel(req) {
				this.btnLoading = true;
				this.uploadLoading = true;
				const formData = new FormData();
				formData.append('file', req.file);

				const res = await uploadFileTmp(formData).catch(err => {
					this.$message({
						message: err.message,
						type: 'error'
					});
				}).finally(() => {
					this.uploadLoading = false;
				});
				if (!res) {
					this.btnLoading = false;
					return;
				}
				const {
					state,
					msg,
					result
				} = res.data;
				if (state != 1 || !result) {
					this.btnLoading = false;
					return this.$message.error(msg || '上传失败');
				}

				this.$request({
						url: '/invoice/record/thirdImport',
						method: 'post',
						params: {
							importType: this.importType,
							filePath: result.url,
							fileName: req.file.name
						}
					})
					.then(res => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.importResult = result;
							this.resultVisible = true;
							this.$emit('onUpdate');
						} else {
							this.$message.error(msg || '导入失败');
						}
					})
					.catch(() => {
						this.$message.error('请求错误');
					})
					.finally(() => {
						this.btnLoading = false;
					});
			},
			// 上传前校验文件格式
			beforeUpload(file) {
				const type = this.$utils.getFileType(file.name);
				const isType = type === 'xls' || type === 'xlsx';
				if (!isType) {
					this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
				}
				return isType;
			},
			// 文件选择变化
			onChange(file) {
				if (file) {
					this.fileList = [{
						...file
					}];
					this.canSubmit = false;
				} else {
					this.canSubmit = true;
				}
			},
			// 删除已选文件
			onRemove() {
				this.canSubmit = true;
			},
			// 提交导出（创建下载任务）
			onSubmitExport() {
				if (!this.exportRange || !this.exportRange[0] || !this.exportRange[1]) {
					return this.$message.error('请选择时间范围');
				}
				this.btnLoading = true;
				this.$request({
						url: '/invoice/record/thirdExport',
						method: 'post',
						data: {
							channel: this.exportForm.channel,
							timeType: this.exportForm.timeType,
							beginTime: this.exportRange[0],
							endTime: this.exportRange[1]
						}
					})
					.then(res => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$confirm('已生成下载任务，请前往下载任务下载', '提示', {
								confirmButtonText: '立即查看',
								cancelButtonText: '稍后再看',
								type: 'success',
								center: true,
								closeOnClickModal: false
							}).then(() => {
								this.close();
								this.$router.push({
									path: '/workbench/downloadList'
								});
							}).catch(() => {});
						} else {
							this.$message.error(msg || '请求失败');
						}
					})
					.catch(() => {
						this.$message.error('请求错误');
					})
					.finally(() => {
						this.btnLoading = false;
					});
			},
			// 复制失败明细
			copyErrors() {
				const text = this.failText;
				if (!text) {
					return;
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(() => {
						this.$message.success('已复制到剪贴板');
					}).catch(() => {
						this.fallbackCopy(text);
					});
				} else {
					this.fallbackCopy(text);
				}
			},
			fallbackCopy(text) {
				const textarea = document.createElement('textarea');
				textarea.value = text;
				document.body.appendChild(textarea);
				textarea.select();
				try {
					document.execCommand('copy');
					this.$message.success('已复制到剪贴板');
				} catch (e) {
					this.$message.error('复制失败，请手动复制');
				}
				document.body.removeChild(textarea);
			},
			// 关闭结果浮层
			closeResult() {
				this.resultVisible = false;
				this.importResult = null;
				this.close();
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-upload-dragger,
	::v-deep .el-upload {
		width: 100%;
	}

	::v-deep .el-upload__tip {
		color: #F56C6C;
	}

	.template-link {
		margin-bottom: 10px;

		span {
			margin-right: 8px;
			color: #909399;
			font-size: 12px;
		}
	}

	.import-summary {
		display: flex;
		justify-content: space-between;

		>div {
			flex: 1;
			text-align: center;

			span {
				display: block;
				font-size: 12px;
				color: #909399;
				margin-bottom: 4px;
			}

			strong {
				font-size: 22px;
				font-weight: 600;
			}

			&.success strong {
				color: #67C23A;
			}

			&.ignored strong {
				color: #E6A23C;
			}

			&.failed strong {
				color: #F56C6C;
			}
		}
	}

	.failure-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 16px 0 8px;

		strong {
			font-size: 14px;
		}

		span {
			font-size: 12px;
			color: #909399;
			margin-left: 8px;
		}
	}

	.failure-text {
		max-height: 240px;
		overflow: auto;
		background: #f5f7fa;
		border-radius: 4px;
		padding: 10px;
		font-size: 12px;
		line-height: 1.8;
		color: #F56C6C;
		white-space: pre-wrap;
		word-break: break-all;
	}
</style>
